<template>
  <HFetchQuery :query="answersQuery">
    <template #default="{ data: questionsAndAnswers }">
      <div v-for="qa in questionsAndAnswers" :key="qa.question_id">
        <label class="question-label">{{ qa.question }}</label>
        <div class="answer-display user-generated-content" v-html="sanitizeRichText(qa.answer ?? '')"></div>
      </div>
    </template>
  </HFetchQuery>

  <hr class="my-8 -ml-6 -mr-6" />

  <header class="font-bold">Private</header>
  <p class="text-sm text-gray-500 mb-8">This is not visible to the agent.</p>

  <HFetchQuery :query="reviewQuery">
    <template #default="{ data: reviewData }">
      <label class="question-label">Your Private Notes (not visible to teammate)</label>
      <div
        class="answer-display user-generated-content"
        v-html="sanitizeRichText(reviewData.pipeline_review.result?.private_notes ?? '')"
      ></div>

      <label class="question-label mb-1">Pipeline Performance</label>
      <ScorePicker :score="reviewData.pipeline_review.result?.score" :disabled="true" />
    </template>
  </HFetchQuery>
</template>

<script setup lang="ts">
import ScorePicker from './ScorePicker.vue';
import { sanitizeRichText } from '@/utilities/sanitization';
import { Api } from '@/api';
import HFetchQuery from '@/lib/hfetch/HFetchQuery.vue';
import { useHFetchQuery } from '@/lib/hfetch/useHFetchQuery';

const props = defineProps<{
  pipelineReview: { id: number };
  teammate: { id: number };
}>();

const answersQuery = useHFetchQuery(() => Api.PipelineReviewAnswers.listAnswers(props.pipelineReview.id));
const reviewQuery = useHFetchQuery(() =>
  Api.PipelineReviews.getPipelineReview(props.teammate.id, props.pipelineReview.id)
);
</script>

<style scoped>
@reference "tailwindcss";

.question-label {
  @apply mt-4 block text-sm leading-5 font-medium text-gray-700;
}

.answer-display {
  @apply shadow-sm bg-gray-200 border p-8 text-sm mt-1 border-gray-300 rounded-md;
}
</style>
